// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
/// <summary>
/// Дефолтовый преобразователь координат - на основании кешайтема
/// </summary>
export class CashItemPointsCoverter {
    constructor(ww, series) {
        this.ww = ww;
        this.series = series;
    }
    /// <summary>
    /// Получить индекс бара по координате X
    /// </summary>
    GetDataIndexByX(x) {
        if (this.series == null) {
            return 0;
        }
        // Bar index from screen coordinates
        const r = this.ww.ClientRectangle;
        const barIndex = this.ww.i1 - (r.X + r.Width - x) / this.ww.XScale + 1;
        return barIndex;
    }
    /// <summary>
    /// Получить значение времени по координате X
    /// </summary>
    GetDataX(x) {
        if (this.series == null) {
            return 0;
        }
        return this.series.FindTimeExactly(this.GetDataIndexByX(x));
    }
    /// <summary>
    /// Получить значение цены по координате Y
    /// </summary>
    GetDataY(y) {
        const ww = this.ww;
        const YScale = ww.YScale;
        if (!YScale)
            return 0;
        const CR = ww.ClientRectangle;
        return (CR.Y + CR.Height - y) / YScale + ww.FminFloatY;
    }
    /// <summary>
    /// Получить значение координаты Y по цене
    /// </summary>
    GetScreenY(dataX) {
        if (this.ww.YScale == 0) {
            return 0;
        }
        // Avoid calling .bottom()
        return (this.ww.ClientRectangle.Y +
            this.ww.ClientRectangle.Height -
            (dataX - this.ww.FminFloatY) * this.ww.YScale /* + ww.PaddingTop */);
    }
    /// <summary>
    /// Получить индекс бара по времени
    /// </summary>
    GetBarIndex(timeX) {
        return this.series.FindIntervalExactly(timeX);
    }
    GetScreenX(barIndex) {
        // Bar index to screen coordinates
        const r = this.ww.ClientRectangle;
        return r.X + r.Width - (this.ww.i1 - barIndex + 1) * this.ww.XScale;
    }
    /// <summary>
    ///
    /// </summary>
    GetScreenXbyTime(timeX, settings = null) {
        if (this.series == null) {
            return 0;
        }
        // Calculate bar index
        const barIndex = this.series.FindIntervalExactly(timeX /*, settings */);
        // Bar index to screen coordinates
        const r = this.ww.ClientRectangle;
        return r.X + r.Width - (this.ww.i1 - barIndex + 1) * this.ww.XScale;
    }
}
